import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=60875367&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=60875367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60875367",
  null
  
)

export default component.exports